import React from 'react';
import { MessageSendErrorType } from './conversationErrors';
import { ReactComponent as ExclamationCircleIcon } from '../../../../icons/error-exclamation-circle.svg';
import './conversation-errors.scss';

interface MessageSendErrorProps {
  errorMessage?: string;
  errorType: MessageSendErrorType;
  recoveryMessage?: string;
  onRetry?: (recoveryMessage?: string) => void;
}

const MessageSendErrorDisplay: React.FC<MessageSendErrorProps> = ({
  errorMessage,
  errorType,
  recoveryMessage,
  onRetry,
}) => {
  // Get appropriate error message based on error type
  const getErrorMessage = () => {
    switch (errorType) {
      case MessageSendErrorType.UNSUCCESSFUL:
        return "We couldn't send your message. The server reported an issue.";
      case MessageSendErrorType.POSSIBLE_NETWORK_ERROR:
        return 'There may be a problem with your internet connection.';
      case MessageSendErrorType.UNKNOWN:
      default:
        return "We couldn't send your message right now.";
    }
  };

  return (
    <div className='chat-sidebar-error'>
      <div className='error-icon'>
        <ExclamationCircleIcon />
      </div>
      <div className='error-details'>
        <div className='chat-error-message'>{getErrorMessage()}</div>
        <div className='chat-error-message'>
          {errorMessage && errorType !== MessageSendErrorType.UNSUCCESSFUL && (
            <span className='error-details-text'>{errorMessage}</span>
          )}
        </div>
      </div>
      {onRetry && (
        <button
          className='retry-button'
          onClick={() => onRetry(recoveryMessage)}
        >
          Try again
        </button>
      )}
    </div>
  );
};

export default MessageSendErrorDisplay;
